import styled from "styled-components";
import { isMobile } from "../../../utils/common";

export const SubscriberContainer = styled.div`
    display:flex;
    align-items:center;
    ${isMobile()?`
        flex-direction:column;
        justify-content:center;
    `:""}
`;

export const MarginBlock = styled.div`
    min-width:30px;
    max-width:30px;
    min-height:30px;
    max-height:30px;
`;